<template>
    <div class="container">
        <div class="paramForm">
            <el-button type="primary" icon="el-icon-refresh" @click="handleSearch">刷新</el-button>
        </div>
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-plus" @click="showCreateMenu">新增菜单</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" row-key="id" border lazy :load="loadChild" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
            <el-table-column prop="name" label="菜单名称"></el-table-column>
            <el-table-column prop="url" label="页面路径" align="center" width="300"></el-table-column>
            <el-table-column prop="icon" label="菜单图标" align="center" width="120">
                <template slot-scope="scope"> <i :class="scope.row.icon" style="font-size: 18px"></i> </template>
            </el-table-column>
            <el-table-column prop="status" label="是否启用" align="center" width="120">
                <template slot-scope="scope">
                <el-switch @change="updateStatus(scope.$index, scope.row)" :active-value="'Y'" :inactive-value="'N'" v-model="scope.row.status"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" align="center" width="120"></el-table-column>
            <el-table-column prop="updatedAt" label="修改时间" align="center" width="150"></el-table-column>
            <el-table-column label="操作" width="140" align="center">
                <template slot-scope="scope">
                <el-button type="text" icon="el-icon-coordinate" @click="showUpdateMenus(scope.$index, scope.row)">修改
                </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 编辑弹出框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="1000px">
            <el-form ref="lockForm" :rules="rules" :model="form" label-width="110px">
                <el-form-item label="菜单名称" prop="name">
                <el-input placeholder v-model="form.name"></el-input>
                </el-form-item>
                <el-row>
                <el-col :span="16">
                    <el-form-item label="菜单图标" prop="icon">
                        <el-input placeholder v-model="form.icon"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label-width="0"> <i :class="form.icon"></i> </el-form-item>
                </el-col>
                </el-row>
                <el-form-item label="上级菜单：" prop="parentId">
                    <el-tree id="wTree" ref="wTree" :data="treeData" node-key="id" border accordion :props="defaultProps" highlight-current :default-expanded-keys="wExpandNodeId">
                </el-tree>
                </el-form-item>
                <el-form-item label="前端URL" prop="url">
                <el-input placeholder v-model="form.url"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                <el-input placeholder v-model="form.sort"></el-input>
                </el-form-item>
                <el-form-item label="启用状态：">
                <el-radio-group v-model="form.status">
                    <el-radio :label="'Y'">是</el-radio>
                    <el-radio :label="'N'">否</el-radio>
                </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="onSubmit" type="primary" >提交</el-button>
                <el-button @click="onCancel">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { menuServiceApi } from '@/api/api-auth';
export default {
    data() {
        return {
            rules: {
                name: [{ required: true, message: '不能为空' }],
                parentId: [{ required: true, message: '不能为空' }],
                url: [{ required: true, message: '不能为空' }]
            },
            dialogVisible: false,
            dialogTitle: '新增菜单',
            tableData: [],
            form: {
                name: '',
                icon: '',
                url: '',
                parentId: '',
                sort: '',
                status: 0
            },
            isEdit: false,
            treeData: [],
            wExpandNodeId: [],
            defaultProps: {children: 'children',label: 'label',isLeaf: 'isLeaf'}
        };
    },
    created() {
        this.handleSearch();
    },
    methods: {
        initDialogData() {
            this.form = {
                name: '',
                parentId: '',
                url: '',
                sort: '',
                status: "Y"
            };
            this.dialogTitle = '';
            this.wExpandNodeId = [];
        },
        loadChild(node, tree, resolve)  {
            if (node && node.id) {
                menuServiceApi.findList({ id: node.id }).then(res => {
                    resolve(res);
                });
            } else {
                resolve([]);
            }
        },
        handleSearch() {
            this.tableData = [];
            menuServiceApi.findList({}).then(res => {
                this.tableData = res;
            });
            this.treeData = [];
            menuServiceApi.findTree().then(res => {
                this.treeData = res;
                this.treeData.unshift({ id: 0, label: '无上级菜单', isLeaf: true });
            });
        },
        showCreateMenu() {
            this.isEdit = false;
            if (this.$refs.lockForm) {
                this.$refs.lockForm.resetFields();
            }
            this.initDialogData();
            this.dialogTitle = '新增菜单';
            this.dialogVisible = true;
            this.form.id = null;
            this.$nextTick(() => {
                let tree = this.$refs.wTree;
                for (var i = 0; i < tree.store._getAllNodes().length; i++) {
                    tree.store._getAllNodes()[i].expanded = false;
                    tree.store._getAllNodes()[i].isCurrent = false;
                }
            });
        },
        showUpdateMenus(index, row) {
            this.isEdit = true;
            if (this.$refs.lockForm) {
                this.$refs.lockForm.resetFields();
            }
            this.form = this._.clone(row);
            this.dialogTitle = '修改菜单';
            this.dialogVisible = true;
            this.$nextTick(() => {
                let tree = this.$refs.wTree;
                for (var i = 0; i < tree.store._getAllNodes().length; i++) {
                    tree.store._getAllNodes()[i].expanded = false;
                }
                // 设置上级菜单选中
                if (row.parentId) {
                    this.wExpandNodeId.push(row.parentId);
                    tree.setCurrentKey(row.parentId);
                } else {
                    tree.setCurrentKey(-1);
                }
            });
        },
        updateStatus(index, row) {
            menuServiceApi.updateStatus({ id: row.id, status: row.status }).then(res => {
                this.$message.success({ message: '修改成功',duration: 1000 });
            });
        },
        onSubmit() {
            let tree = this.$refs.wTree;
            let parentId = tree.getCurrentKey();
            if (parentId != null && parentId != undefined) {
                this.form.parentId = parentId;
            }else{
                this.$message.warning("请选择上级菜单");
                return;
            }
            this.$refs.lockForm.validate(valid => {
                if (!valid) {
                    return;
                }
                menuServiceApi.update(this.form).then(res => {
                    if (res.result) {
                        this.$message.success("更新成功");
                        this.onCancel();
                        this.initListData();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            });
        },
        onCancel() {
            this.$refs.lockForm.resetFields();
            this.dialogVisible = false;
            this.initDialogData();
        }
    }
};
</script>